export const CSV_OPTIONS = {
                                header: true,
                                dynamicTyping: true,
                                skipEmptyLines: true,
                                transformHeader: header => header.toLowerCase().replace(/\W/g, '_')
                            };
